import { Dialog, DialogContent, DialogTitle } from '@/components/ui/dialog'
import {
  queryFilterFormSchema,
  QueryFilterFormType,
  QueryFilterModelForm,
} from './query-filter-modal-form'
import * as VisuallyHidden from '@radix-ui/react-visually-hidden'
import { useForm } from 'react-hook-form'
import { zodResolver } from '@hookform/resolvers/zod'
import { useQueryFilterStore } from './query-filter-store'

interface QueryFilterModalProps {
  isOpen: boolean
  onClose: () => void
  setFilterGeoJson: any
  setMapBounds: (bounds: any) => void
  setVisibility: any
  isTutorial?: boolean
  onSubmitDone: (data: any) => void
}

export default function QueryFilterModel({
  isOpen,
  onClose,
  onSubmitDone,
  isTutorial = false,
}: QueryFilterModalProps): JSX.Element {
  const { formData } = useQueryFilterStore()
  const form = useForm<QueryFilterFormType>({
    mode: 'onChange',
    resolver: zodResolver(queryFilterFormSchema),
    defaultValues: formData,
  })

  return (
    <Dialog open={isOpen} onOpenChange={onClose}>
      <DialogContent
        onPointerDownOutside={(e) => e.preventDefault()}
        className="max-w-[600px] !p-5 rounded-md !gap-2 w-full sm:rounded-md"
      >
        <VisuallyHidden.Root>
          <DialogTitle />
        </VisuallyHidden.Root>
        <div className="flex justify-between items-center">
          <p className="text-base">Query Filter Criteria</p>
          <button
            onClick={onClose}
            className="text-gray-500 hover:text-gray-700"
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              className="h-6 w-6"
              fill="none"
              viewBox="0 0 24 24"
              stroke="currentColor"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={2}
                d="M6 18L18 6M6 6l12 12"
              />
            </svg>
          </button>
        </div>{' '}
        <div className="px-0">
          <QueryFilterModelForm
            form={form}
            onSubmitDone={(v) => {
              onSubmitDone(v)
              onClose()
            }}
            isTutorial={isTutorial}
          />
        </div>
      </DialogContent>
    </Dialog>
  )
}
